import { Auth } from "aws-amplify";
import { FC } from 'react';
// import { useForm } from 'react-hook-form';
import AuthHead from "./AuthHead";
import AuthMedia from './authMedia';
import Headline4 from '../../components/headings/Headline4';
import Styles from "./styles.module.scss";
import classnames from "classnames";



export type VerificationFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  password: any;
  vericode: any;
};

export const VerificationForm: FC = () => {
  // const {
  //   formState: { errors },
  // } = useForm<VerificationFormFields>();


  Auth.configure({
    userPoolId: "ap-south-1_xW3Zsub3t",
    userPoolWebClientId: "2jn6qgntppsud848ri333cud5s", // app client id
    region: "ap-south-1",
    oauth: {
      region: "ap-south-1",
      domain: "authmyworkplace.ellow.io",
      scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
      redirectSignIn: "https://myworkplace.ellow.io/login?provider=google",
      redirectSignOut: "https://myworkplace.ellow.io/login",
      responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  })


  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <aside className={Styles.loginSignupWapper}>
            <div className={Styles.alignCenter}>
            <Headline4>Thank you for registering with us!</Headline4> 
            <div className={classnames(Styles.alreadyRegistered, Styles.mt_0)}>
              {/* {`Click the link in the email we just sent to `}
              <Link to="/"> { email } </Link>
              {`to verify your new ellow.io account.`} */}
              Please check your mail inbox. Click the link you received to verify the profile with us.
              <br/><br/>
              If you don't see an email in inbox, please check spam folder     
            </div>
            </div>
          </aside>
        </div>
        <AuthMedia/>
      </div>
    </section>
  );
}

export default VerificationForm;


